var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{
        active: !_vm.exactActiveOnly ? _vm.isActive : false,
        'exact-active': _vm.isExactActive
    },attrs:{"data-closable":_vm.closableName},on:{"click":_vm.clickHandler}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }